export default __webpack_public_path__ + "static/media/WashingtonDC.1922b328.webp";